// Whether a step of the MCQ form has been answered well enough to move
// on. Shared by the two dialogs that ask these questions -- the one on
// the course list and the one inside a course -- so they cannot drift.
//
// The values are checked as well as Formik's `errors`, not instead of
// it: `errors` is empty until validation has run at least once, so on a
// freshly opened form an untouched step would otherwise look valid.

const filled = (v) => String(v ?? "").trim().length > 0;

// `trainerRequired` mirrors the Yup schemas, where the trainer is only
// required of an admin -- a trainer's own name is filled in for them and
// the field is read-only.
export const mcqStepComplete = (step, values = {}, errors = {}, trainerRequired = true) => {
  if (step === 1) {
    return filled(values.question) && !errors.question;
  }

  if (step === 2) {
    const optionsFilled = [1, 2, 3, 4].every((n) =>
      filled(values[`option${n}`]),
    );
    const optionsClean = [1, 2, 3, 4].every((n) => !errors[`option${n}`]);
    // correctAnswer is a 1-4 number; "" is the unchosen state.
    const answerChosen = filled(values.correctAnswer);
    return optionsFilled && optionsClean && answerChosen && !errors.correctAnswer;
  }

  if (step === 3) {
    // The course list's form picks courses; the in-course form already
    // knows its course and only needs the trainer. Whichever field the
    // form carries is the one that has to be answered.
    const needsCourses = Object.prototype.hasOwnProperty.call(
      values,
      "selectedCourses",
    );
    const coursesOk = needsCourses
      ? Array.isArray(values.selectedCourses) &&
        values.selectedCourses.length > 0 &&
        !errors.selectedCourses
      : true;

    // The two forms hold the trainer differently: the course list keeps
    // the whole option object, the in-course form keeps its id string.
    const t = values.selectedTrainer;
    const trainerChosen = Array.isArray(t)
      ? t.length > 0
      : t && typeof t === "object"
        ? Boolean(t.value ?? t.id)
        : filled(t);

    const trainerOk = trainerRequired
      ? trainerChosen && !errors.selectedTrainer
      : !errors.selectedTrainer;

    return coursesOk && trainerOk;
  }

  return true;
};
